import PropTypes from 'prop-types';
import React from 'react';

import AuditResult from './AuditResult';

const AuditResults = ({ data }) => {
  if (!data || !data.length) {
    return <span className='font-semibold mt-4 group-has-[.invalid-email]:hidden mt-4'>No results to show.</span>
  }

  return <div className='flex flex-col gap-2 mt-4'>
    {data.map(audit => <AuditResult key={audit[0]} id={audit[0]} impressions={audit[1]} />)}
  </div>
}

AuditResults.propTypes = {
  data: PropTypes.array,
};

export default AuditResults;
